import React from 'react';
import PropTypes from 'prop-types';
import {SlideBlockContext} from '../SlideBlock';
import {HexagonCard} from '@learningblocks/storybook-components';
import '../SharedComponents/Styles/DesignSlideJointGroup.scss';
import './style.scss';

/**
 * StartNode
 *  - Component that will list the LINK_HEXAGON_MODAL components
 *    that serve as starting node for DesignSlide
 */
export function StartNode({inputNodes, overrides}) {
  const {getTabIndex} = React.useContext(SlideBlockContext);

  const renderNode = (node, key) => (
    <HexagonCard key={key} {...node} tabIndex={getTabIndex()} />
  );

  const renderOverrideNode = (node, key) =>
    React.cloneElement(overrides, {
      key,
      tabIndex: getTabIndex(),
      ...node,
    });

  const wrapperClass = () => {
    const count = inputNodes.length;
    return [
      `designSlide_jointGroup`,
      `designSlide_startNode`,
      `totalNodes_${count}`,
    ].join(' ');
  };

  const renderStartNodeComponent = () => {
    return overrides
      ? inputNodes.map(renderOverrideNode)
      : inputNodes.map(renderNode);
  };

  return <div className={wrapperClass()}>{renderStartNodeComponent()}</div>;
}

StartNode.propTypes = {
  /**
   * List of nodes to be displayed as Input Nodes
   */
  inputNodes: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Type of component
       */
      type: PropTypes.oneOf(['LINK_HEXAGON_MODAL']),
      /**
       * Image displayed on card
       */
      image: PropTypes.string.isRequired,
      /**
       * Data to be displayed in modal
       */
      modal: PropTypes.object.isRequired,
    })
  ).isRequired,
};

StartNode.defaultProps = {
  inputNodes: [],
};
